import { Flex } from "rebass/styled-components";
import styled from "styled-components";

import { LoadingSkeleton } from "../../../Components/Skeloton";
import { MainRail, StickySideRail, Page } from "../../../Components/Wrappers";
import BackgroundImageProfile from "../../../../assets/images/backgrounds/profileBG.jpg";

const ProfileSkeleton = () => (
  <>
    <StyleProfile flexDirection="column" mb={6}>
      <StyledPage>
        <Flex
          style={{ gap: 12, position: "relative" }}
          flexDirection="column"
          width="100%"
          py={12}
        >
          <Flex alignItems="center" mb={4} ml={100} pt={44}>
            <LoadingSkeleton
              height="100px"
              width="100px"
              style={{ borderRadius: "50%", marginRight: "20px" }}
            />
            <Flex flexDirection="column" width="50%">
              <LoadingSkeleton
                height="30px"
                width="40%"
                style={{ marginBottom: "10px" }}
              />
              <LoadingSkeleton height="20px" width="60%" />
            </Flex>
          </Flex>
          <Flex justifyContent="space-between" width="100%" maxWidth="400px">
            <LoadingSkeleton height="40px" width="30%" />
            <LoadingSkeleton height="40px" width="30%" />
            <LoadingSkeleton height="40px" width="30%" />
          </Flex>
        </Flex>
      </StyledPage>
    </StyleProfile>

    <StyledPage>
      <Flex flexDirection="column" flexBasis={1350}>
        <LoadingSkeleton
          height="40px"
          width="50%"
          style={{ marginBottom: "20px" }}
        />
        <LoadingSkeleton
          height="40px"
          width="100%"
          style={{ marginBottom: "20px" }}
        />
        <MainRail>
          <Flex flexDirection="column" width="100%" style={{ gap: 16 }}>
            {[...Array(3)].map((_, index) => (
              <LoadingSkeleton key={index} height="250px" width="100%" />
            ))}
          </Flex>
        </MainRail>
      </Flex>
      <StickySideRail showOnMobile={false} display="flex">
        <Flex flexDirection="column" width="100%" p={3} style={{ gap: 12 }}>
          <LoadingSkeleton height="30px" width="60%" />
          <LoadingSkeleton height="20px" width="100%" />
          <LoadingSkeleton height="20px" width="90%" />
          <LoadingSkeleton height="20px" width="80%" />
        </Flex>
        <LoadingSkeleton
          height="200px"
          width="100%"
          style={{ marginBottom: "10px" }}
        />
        <LoadingSkeleton height="150px" width="100%" />
      </StickySideRail>
    </StyledPage>
  </>
);

const StyleProfile = styled(Flex)`
  background: rgb(24, 37, 45);
  background-position: 0px;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${BackgroundImageProfile});

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    background-size: cover;
    background-position: center;
  }
`;

const StyledPage = styled(Page)`
  @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
    padding-left: 20px;
  }
`;

export { ProfileSkeleton };
